var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4702 1.9447H18.1622C18.9316 1.9447 19.5553 2.56843 19.5553 3.33783V9.02984C19.5553 9.39931 19.4085 9.75367 19.1473 10.0149L9.74369 19.4185C9.19963 19.9625 8.31756 19.9625 7.77351 19.4185L2.0815 13.7265C1.53745 13.1825 1.53745 12.3004 2.0815 11.7563L11.4851 2.35274C11.7463 2.09148 12.1007 1.9447 12.4702 1.9447Z",
    stroke: "#FF0000",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0276 7.16891C14.6429 7.16891 14.3311 6.85705 14.3311 6.47235C14.3311 6.08765 14.6429 5.77579 15.0276 5.77579C15.4123 5.77579 15.7242 6.08765 15.7242 6.47235C15.7242 6.85705 15.4123 7.16891 15.0276 7.16891Z",
    stroke: "#FF0000",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.ff6d9b1c85eda71110ad0859b6c3e0b6.svg";
export { ForwardRef as ReactComponent };